/**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $wrapperMenu    = $el.find('.wrapper-menu');
const $btnMenu        = $el.find('.btn-menu');
const $mainMenu       = $el.find('.main-menu');
const $menuLabel      = $btnMenu.find('.menu-label');
const $linkToSub      = $el.find('.link-to-sub');
const $productsMenu   = $el.find('.products-menu');
const $submenuTitle   = $el.find('.submenu-title');
const $subList        = $el.find('.submenu ul');
const $productSubmenu = $productsMenu.find('.product-submenu');

const $modalFaq        = $('[data-component="modals/modal-faq"]');
const $btnOpenModalFaq = $el.find('[data-open-modal-faq]');

const $toggleSearch   = el.querySelector('.toggle-search');
const $searchForm     = el.querySelector('.search-box');
const $btnCloseSearch = el.querySelector('.btn-close-search');
const $cleanSearch    = el.querySelector('.clean-search');
const $btnLang        = el.querySelector('.btn-lang');
const $inputSearch    = $searchForm.querySelector('input');

const menuControl = {
    opened: false,
    labelfalse: () => {
        return 'Menu'
    },
    labeltrue: () => {
        return $btnMenu.data('close-label')
    },
};

const toggleMenu = (close = false) => {
    if(close) {
        menuControl.opened = false;
    } else {
        menuControl.opened = !menuControl.opened;
    }

    if (Is.mobile.ANY()) {
        if(menuControl.opened) {
            $body.addClass('modal-opened menu-opened');
        } else {
            $body.removeClass('modal-opened menu-opened');
        }
    }

    $btnMenu.attr('aria-expanded', menuControl.opened);
    $wrapperMenu.add($el).attr('data-show', menuControl.opened);
    $menuLabel.text(menuControl['label' + menuControl.opened]);
}

$btnOpenModalFaq.on('click', function() {
    toggleMenu(true);

    $modalFaq.trigger('open');
});

$btnMenu.on('click', function() {
    const $this = $(this);

    if ($this.data('back') && Is.mobile.ANY()) {
        $this.data('back', false);
        $this.attr('aria-back', false);

        $productSubmenu.add($linkToSub).add($mainMenu).removeClass('active');
    } else {
        toggleMenu();
    }
});

$linkToSub.on(wW <= 768 ? 'click' : 'mouseover', function() {
    const $this = $(this);
    const id = $this.attr('aria-controls');

    if (Is.mobile.ANY()) {
        $btnMenu.data('back', true);
        $btnMenu.attr('aria-back', true);
    }

    $productSubmenu.add($linkToSub).removeClass('active');
    $mainMenu.add($this).addClass('active');
    $productsMenu.find('#' + id).addClass('active');
});

$submenuTitle.on('click', function() {
    const $this = $(this);

    $subList.removeClass('active');
    $this.next().addClass('active');
});

// $toggleSearch.addEventListener('click', function() {
//     $searchForm.classList.add('is-active');
//     $toggleSearch.classList.add('is-active');
//     $btnLang.classList.remove('show-menu');

//     setTimeout(function() {
//         $inputSearch.focus();
//     }, 200);
// });

$btnCloseSearch.addEventListener('click', function(e) {
    e.preventDefault();

    $inputSearch.value = '';
    $cleanSearch.classList.remove('is-active');
    $toggleSearch.classList.remove('is-active');
    $searchForm.classList.remove('is-active');
});

$btnLang.addEventListener('click', function(e) {
    e.preventDefault();

    $btnLang.classList.toggle('show-menu');
});

$window.on('scroll', function() {
    if (menuControl.opened) {
        $btnMenu.trigger('click');
    }
});